import { Theme, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Accordion(theme: Theme) {
  const isLight = theme.palette.mode === 'light';
  const boxShadow = `0 0 2px 0 ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.9)}, ${theme.customShadows.z12}`;

  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow,
          borderRadius: theme.shape.borderRadius,
          padding: '0px !important',
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(1),
          '&.Mui-disabled': {
            opacity: 1,
            color: theme.palette.action.disabled,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },
          '&.Mui-expanded': {
            opacity: 1,
            minHeight: '48px',
          },
        },
        content: {
          margin: '0 !important',
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
